import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const searchCarListMarks = (
    searchTerm: string
) => async (
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        search: searchTerm,
    }
    const config = {
        headers: { Authorization: `${anchor} ${localStorage.getItem('accessToken')}` }
    }
    dispatch({ type: storeDispatchTypes.seCarsLoader, value: { field: 'marks', value: true } })
    try {
        const { data: { status, marks } } = await apiInstance.post('/getCarsSelectSearchMark', params, config)
        if (status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setMarksCars,
                value: {
                    marks
                }
            })
        }
    } catch (e) {
        console.error('load cars marks failed', e)
    }
    dispatch({ type: storeDispatchTypes.seCarsLoader, value: { field: 'marks', value: false } })
}

export default searchCarListMarks
